/* [Modified by Codex at 2026-09-09] 在滚动达到页面可滚动距离三成时显示返回入口。 */
class BackToTop extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('.back-to-top__button');
    this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.animationFrame = null;
    this.onScroll = this.onScroll.bind(this);
    this.onClick = this.onClick.bind(this);
  }

  connectedCallback() {
    if (!this.button) return;

    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onScroll);
    this.button.addEventListener('click', this.onClick);
    this.updateVisibility();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onScroll);
    this.button?.removeEventListener('click', this.onClick);

    if (this.animationFrame !== null) {
      window.cancelAnimationFrame(this.animationFrame);
    }
  }

  onScroll() {
    if (this.animationFrame !== null) return;

    this.animationFrame = window.requestAnimationFrame(() => {
      this.updateVisibility();
      this.animationFrame = null;
    });
  }

  updateVisibility() {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    const scrollableDistance = Math.max(document.documentElement.scrollHeight - window.innerHeight, 0);
    const shouldShow = scrollableDistance > 0 && scrollTop >= scrollableDistance * 0.3;

    this.classList.toggle('is-visible', shouldShow);
    this.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    this.button.tabIndex = shouldShow ? 0 : -1;
  }

  onClick() {
    window.scrollTo({
      top: 0,
      behavior: this.reduceMotion.matches ? 'auto' : 'smooth',
    });
  }
}

if (!customElements.get('back-to-top')) {
  customElements.define('back-to-top', BackToTop);
}
/* [End] */
